import {
  FormField,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { useRepositoryFormContext } from './RepositoryFormContext';

type ProjectForm = {
  repository: string;
  branch: string;
  projectDir: string;
};

type Props = {
  register: UseFormRegister<ProjectForm>;
  errors: FieldErrors<ProjectForm>;
};

const ProjectConfigFields = ({ register, errors }: Props) => {
  const { isLoading } = useRepositoryFormContext();

  return (
    <>
      <FormField title="Repository" errorMessage={errors.repository?.message}>
        <TextField
          {...register('repository', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="project/repository"
          disabled={isLoading}
          size="large"
        />
      </FormField>

      <FormField
        title="Environment base branch"
        description="Target branch of pull requests opened by Elementary in this environment (leave empty to use your default branch)"
        optional
      >
        <TextField
          {...register('branch')}
          placeholder="e.g. main"
          variant="outlined"
          disabled={isLoading}
          size="large"
        />
      </FormField>

      <FormField
        title="Project path"
        description="The path of the directory in which your dbt_project.yml file is located"
        optional
      >
        <TextField
          {...register('projectDir')}
          placeholder="e.g. dbt_project/"
          variant="outlined"
          disabled={isLoading}
          size="large"
        />
      </FormField>
    </>
  );
};

export default ProjectConfigFields;
